import { EnumOption } from "./enum-option"

export const MatterReceiptStatus = {
  Pending: 0,
  Approved: 1,
  Denied: 2,
  RFE: 3,
  Withdrawn: 4,
  Shipped: 5
}

export const MatterReceiptStatusList: EnumOption[] = [
    { value: MatterReceiptStatus.Pending, label: 'Pending' },
    { value: MatterReceiptStatus.Approved, label: 'Approved' },
    { value: MatterReceiptStatus.Denied, label: 'Denied' },
    { value: MatterReceiptStatus.RFE, label: 'RFE' },
    { value: MatterReceiptStatus.Withdrawn, label: 'Withdrawn' },
    { value: MatterReceiptStatus.Shipped, label: 'Shipped' },
]
